import { ReactNode } from 'react';

import { COHORTS, useCohort } from '@/components/user-context/helpers/cohorts';

import { ExistingUser as DefaultExistingUser } from './components/existing-user/existing-user';
import { ManagedUser as DefaultManagedUser } from './components/managed-user/managed-user';
import { NewUser as DefaultNewUser } from './components/new-user/new-user';
import { UpgradeEligibleUser as DefaultUpgradeEligibleUser } from './components/upgrade-eligible-user/upgrade-eligible-user';
import { WeekOneUser as DefaultWeekOneUser } from './components/week-one-user/week-one-user';

export const SiteActivationSwitcher = ({
	ExistingUser = <DefaultExistingUser />,
	ManagedUser = <DefaultManagedUser />,
	NewUser = <DefaultNewUser />,
	WeekOneUser = <DefaultWeekOneUser />,
	UpgradeEligibleUser = <DefaultUpgradeEligibleUser />,
	CurrentProductJoinableUser,
	CurrentProductUser,
	UpliftEligibleUser,
	CrossflowEligibleUser,
	useContactExpandCohortLogic,
}: {
	ExistingUser?: ReactNode;
	ManagedUser?: ReactNode;
	NewUser?: ReactNode;
	WeekOneUser?: ReactNode;
	UpgradeEligibleUser?: ReactNode;
	CurrentProductJoinableUser?: ReactNode;
	CurrentProductUser?: ReactNode;
	UpliftEligibleUser?: ReactNode;
	CrossflowEligibleUser?: ReactNode;
	useContactExpandCohortLogic?: boolean;
	// eslint-disable-next-line complexity
}) => {
	const cohort = useCohort(useContactExpandCohortLogic);

	if (cohort === COHORTS.MANAGED_USER && ManagedUser) {
		return ManagedUser;
	}

	if (cohort === COHORTS.WEEK_ONE_USER && WeekOneUser) {
		return WeekOneUser;
	}

	if (cohort === COHORTS.CURRENT_PRODUCT_JOINABLE_USER && CurrentProductJoinableUser) {
		return CurrentProductJoinableUser;
	}

	if (cohort === COHORTS.CURRENT_PRODUCT_USER && CurrentProductUser) {
		return CurrentProductUser;
	}

	if (cohort === COHORTS.NEW_USER && NewUser) {
		return NewUser;
	}

	if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER && UpgradeEligibleUser) {
		return UpgradeEligibleUser;
	}

	if (cohort === COHORTS.UPLIFT_ELIGIBLE_USER && UpliftEligibleUser) {
		return UpliftEligibleUser;
	}

	if (cohort === COHORTS.CROSSFLOW_ELIGIBLE_USER && CrossflowEligibleUser) {
		return CrossflowEligibleUser;
	}

	return ExistingUser;
};
